import { render, staticRenderFns } from "./DraggableTreeview.vue?vue&type=template&id=1fc85600&"
import script from "./DraggableTreeview.vue?vue&type=script&lang=js&"
export * from "./DraggableTreeview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports